/**
 * Qué advertencias de campo (`FIELD_CAVEATS`, ver `utils/fieldCaveats.js`) corresponden a un bloque
 * del informe, para el ⓘ de su encabezado (card ctbIdOOc).
 *
 * Se miran las DIMENSIONES que el bloque muestra. La fuente preferida es lo que el motor devolvió
 * (`rendered.data.dimension` en barras y torta, `rendered.data.dimensions` en la tabla): así funciona
 * igual en el editor, en el portal y en una foto publicada, que no reciben la paleta. Sin datos
 * todavía (cargando), sale de la configuración del bloque; una tabla sin columnas propias muestra la
 * paleta entera, y por eso va por `tableColumnsOf`.
 */
import {caveatsOfFields} from '../../../utils/fieldCaveats';
import {PANEL_TYPES, tableColumnsOf} from './informeModel';

export function panelDimensionIds(panel, rendered, fields) {
    const data = rendered && rendered.data;
    if (data && Array.isArray(data.dimensions)) return data.dimensions;
    if (data && data.dimension) return [data.dimension];
    if (!panel) return [];
    if (panel.dimension) return [panel.dimension];
    if (panel.type === PANEL_TYPES.TABLE && fields) return tableColumnsOf(panel, fields).dimensions;
    return panel.dimensions || [];
}

export function panelCaveats(panel, rendered, fields, fieldsData) {
    return caveatsOfFields(fieldsData, panelDimensionIds(panel, rendered, fields));
}
